import { useSopStore } from './useSopStore';
import { useSopSelectionStore } from './useSopSelectionStore';
import { useSopEditStore } from './useSopEditStore';
import { useTrackChangesStore } from './useTrackChangesStore';

// Initialize useTrackChangesStore with current state from other stores
const initializeTrackChangesStore = () => {
  const sopStoreState = useSopStore.getState();
  const selectionStoreState = useSopSelectionStore.getState();
  const editStoreState = useSopEditStore.getState();
  
  useTrackChangesStore.setState({
    sops: sopStoreState.sops,
    isLoading: sopStoreState.isLoading,
    error: sopStoreState.error || editStoreState.error,
    selectedSOP: selectionStoreState.selectedSOP,
    selectedVersion: selectionStoreState.selectedVersion,
    latestVersion: selectionStoreState.latestVersion,
    isUpdating: editStoreState.isUpdating,
  });
};

// Initialize immediately
initializeTrackChangesStore();

/** Skip selection refresh when on Compare versions page to avoid side effects when opening from list. */
function isVersionsCompareRoute(): boolean {
  return /^\/sop\/[^/]+\/versions\/?$/.test(
    typeof window !== 'undefined' ? window.location.pathname : ''
  );
}

// Keep useTrackChangesStore in sync with other stores
useSopStore.subscribe(
  (state) => state.sops,
  (sops) => {
    useTrackChangesStore.setState({ sops });

    if (sops.length > 0 && !isVersionsCompareRoute()) {
      const selectionState = useSopSelectionStore.getState();
      const { selectedSOP, selectedVersion } = selectionState;
      if (selectedSOP) {
        const sop = sops.find((s) => s.sopId === selectedSOP);
        if (sop) {
          const newLatest = sop.getLatestVersion();
          const currentHasSteps = (selectedVersion?.steps?.length ?? 0) > 0;
          const newHasSteps = (newLatest?.steps?.length ?? 0) > 0;
          if (newHasSteps || !currentHasSteps) {
            selectionState.refreshSelectedSOP();
          }
        }
      }
    }
  }
);

useSopStore.subscribe(
  (state) => state.isLoading,
  (isLoading) => {
    useTrackChangesStore.setState({ isLoading });
  }
);

useSopStore.subscribe(
  (state) => state.error,
  (error) => {
    const editError = useSopEditStore.getState().error;
    useTrackChangesStore.setState({ error: error || editError });
  }
);

useSopEditStore.subscribe(
  (state) => state.error,
  (error) => {
    const sopError = useSopStore.getState().error;
    useTrackChangesStore.setState({ error: sopError || error });
  }
);

useSopSelectionStore.subscribe(
  (state) => state.selectedSOP,
  (selectedSOP) => {
    useTrackChangesStore.setState({ selectedSOP });
  }
);

useSopSelectionStore.subscribe(
  (state) => state.selectedVersion,
  (selectedVersion) => {
    useTrackChangesStore.setState({ selectedVersion });
  }
);

useSopSelectionStore.subscribe(
  (state) => state.latestVersion,
  (latestVersion) => {
    useTrackChangesStore.setState({ latestVersion });
  }
);

useSopEditStore.subscribe(
  (state) => state.isUpdating,
  (isUpdating) => {
    useTrackChangesStore.setState({ isUpdating });
  }
);

// Track error states for potential error reporting
useSopStore.subscribe(
  (state) => state.error,
  (error) => {
    if (error) {
      console.error('SOP Store Error:', error);
    }
  }
);

useSopEditStore.subscribe(
  (state) => state.error,
  (error) => {
    if (error) {
      console.error('SOP Edit Store Error:', error);
    }
  }
); 